import React from 'react';
import { observer } from 'mobx-react';

// Components
import Tabs from '../../common/Tabs';
import Overview from './Overview';
import Incidents from './Incidents';
// import Events from './Events';
import Images from './Images';
import Shares from './Shares';

const SessionDetails = props => {
  // Get values from props
  const { AppStore } = props.store;
  const translation = AppStore.translation.SessionDetails;
    
  const tabs = [
    {
      title: translation.overview.title
    }, {
      title: translation.incidents.title
    },
    // {
    //   title: translation.events.title
    // },
    {
      title: translation.images.title
    }
  ];

  const tabContents = [
    <Overview {...props} translation={translation.overview} />,
    <Incidents {...props} translation={translation.incidents} />,
    // <Events {...props} translation={translation.events} />,
    <Images {...props} translation={translation.images} />
  ];

  // Add sharing tab for non-shared viewers
  if (!AppStore.sharedViewer) {
    tabs.push({ title: translation.shares.title });
    tabContents.push(<Shares {...props} translation={translation.shares} />);
  }

  return (
    <div className="page">
      <Tabs
        {...props}
        activeTab={0}
        tabClassName="tab--sm"
        tabContents={tabContents}
        tabs={tabs}
      />
    </div>
  );
};

export default SessionDetails;
